import { c as _c } from "react/compiler-runtime";
import { Badge, Box, Dialog, Heading, HStack, Link, Separator, SimpleGrid, Spacer } from '@chakra-ui/react';
import { accountCancelHref } from '@src/components/sco/Account/CancelSubscriptionOptions/cancellationReasons';
import { BillingStatementList } from '@src/components/sco/Account/UserSubscriptionList/BillingStatementList';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { ScoSubscription } from '@src/graphql-types';
import { startups3Url } from '@src/lib/startups-url';
import moment from 'moment';
import React, { useState } from 'react';
type SubscriptionListItemProps = {
  subscription: ScoSubscription;
};
export const SubscriptionListItem = props => {
  const $ = _c(88);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const {
    subscription
  } = props;
  const [showStatementsModal, setShowStatementsModal] = useState(false);
  const recurringCents = subscription.nextAssessmentAmountInCents ?? subscription.scoProduct?.effectivePricingInCents?.recurring;
  const recurringPriceInDollars = (recurringCents != null && recurringCents > 0 ? recurringCents / 100 : null) || subscription.product?.effectivePrices?.recurring || null;
  let t0;
  if ($[0] !== subscription.chargebeeCustomerId || $[1] !== subscription.subscriptionId || $[2] !== subscription.updatePaymentMethodLink) {
    t0 = subscription.updatePaymentMethodLink || (subscription.chargebeeCustomerId ? startups3Url(`/billing/subscriptions/${subscription.subscriptionId}/cb-update-payment-method`) : null);
    $[0] = subscription.chargebeeCustomerId;
    $[1] = subscription.subscriptionId;
    $[2] = subscription.updatePaymentMethodLink;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const updatePaymentMethodHref = t0;
  let t1;
  if ($[4] !== getBreakpointValue) {
    t1 = getBreakpointValue(["1em", "1em", "1.5em"]);
    $[4] = getBreakpointValue;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== getBreakpointValue) {
    t2 = getBreakpointValue([1, 1, 1, 3]);
    $[6] = getBreakpointValue;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <HStack justify="space-between"><Heading size="md">Product</Heading></HStack>;
    t4 = <Separator marginY={3} />;
    $[8] = t3;
    $[9] = t4;
  } else {
    t3 = $[8];
    t4 = $[9];
  }
  let t5;
  if ($[10] !== subscription.product.name) {
    t5 = <strong>{subscription.product.name}</strong>;
    $[10] = subscription.product.name;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Spacer height="0.25em" />;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = subscription.product.durationInYears ? `${subscription.product.durationInYears} Years of Access` : subscription.isLifetime ? subscription.product?.specialTermsNote || "Lifetime Access" : subscription.product.term.description;
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Spacer height="0.25em" />;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== subscription.activatedAt) {
    t9 = subscription.activatedAt && <span>{"Started on "}{moment(subscription.activatedAt).format("ll")}</span>;
    $[14] = subscription.activatedAt;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t5 || $[17] !== t7 || $[18] !== t9) {
    t10 = <Box>{t3}{t4}<Box opacity={1}>{t5}{t6}{t7}{t8}{t9}</Box></Box>;
    $[16] = t5;
    $[17] = t7;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Heading size="md">{"Status & Renewal"}</Heading>;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== subscription.canBeCanceled || $[22] !== subscription.subscriptionId) {
    t12 = subscription.canBeCanceled && <Link asChild={true} fontSize="xs" variant="underline"><NextLink href={accountCancelHref(subscription.subscriptionId)}>Cancel</NextLink></Link>;
    $[21] = subscription.canBeCanceled;
    $[22] = subscription.subscriptionId;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t12) {
    t13 = <HStack justify="space-between">{t11}{t12}</HStack>;
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Separator marginY={3} />;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  const t15 = stateColors[subscription.state];
  const t16 = stateColors[subscription.state] ? undefined : "gray";
  const t17 = stateLabels[subscription.state] || subscription.state;
  let t18;
  if ($[27] !== t15 || $[28] !== t16 || $[29] !== t17) {
    t18 = <Badge color={t15} colorPalette={t16}>{t17}</Badge>;
    $[27] = t15;
    $[28] = t16;
    $[29] = t17;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Spacer height="0.25em" />;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] !== subscription.canceledAt) {
    t20 = subscription.canceledAt && <><span>{"Canceled on "}{moment(subscription.canceledAt).format("ll")}</span><Spacer height="0.25em" /></>;
    $[32] = subscription.canceledAt;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== recurringPriceInDollars || $[35] !== subscription.nextAssessmentAt) {
    t21 = subscription.nextAssessmentAt && <span>{"Renews on "}{moment(subscription.nextAssessmentAt).format("ll")}{recurringPriceInDollars ? ` for $${recurringPriceInDollars}` : ""}</span>;
    $[34] = recurringPriceInDollars;
    $[35] = subscription.nextAssessmentAt;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] !== t18 || $[38] !== t20 || $[39] !== t21) {
    t22 = <Box opacity={1}>{t18}{t19}{t20}{t21}</Box>;
    $[37] = t18;
    $[38] = t20;
    $[39] = t21;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  let t23;
  if ($[41] !== t13 || $[42] !== t22) {
    t23 = <Box>{t13}{t14}{t22}</Box>;
    $[41] = t13;
    $[42] = t22;
    $[43] = t23;
  } else {
    t23 = $[43];
  }
  let t24;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <Heading size="md">Payment Method</Heading>;
    $[44] = t24;
  } else {
    t24 = $[44];
  }
  let t25;
  if ($[45] !== updatePaymentMethodHref) {
    t25 = updatePaymentMethodHref && <Link asChild={true} fontSize="xs" variant="underline"><NextLink href={updatePaymentMethodHref} rel="noopener noreferrer" target="_blank">Update</NextLink></Link>;
    $[45] = updatePaymentMethodHref;
    $[46] = t25;
  } else {
    t25 = $[46];
  }
  let t26;
  if ($[47] !== t25) {
    t26 = <HStack justify="space-between">{t24}{t25}</HStack>;
    $[47] = t25;
    $[48] = t26;
  } else {
    t26 = $[48];
  }
  let t27;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <Separator marginY={3} />;
    $[49] = t27;
  } else {
    t27 = $[49];
  }
  let t28;
  if ($[50] !== subscription.appliedCouponCode) {
    t28 = subscription.appliedCouponCode && <><strong>{"Code: "}</strong> <code>{subscription.appliedCouponCode}</code><Spacer height="0.25em" /></>;
    $[50] = subscription.appliedCouponCode;
    $[51] = t28;
  } else {
    t28 = $[51];
  }
  const t29 = subscription.cardLabel || "No payment method on file.";
  let t30;
  if ($[52] !== t29) {
    t30 = <strong>{t29}</strong>;
    $[52] = t29;
    $[53] = t30;
  } else {
    t30 = $[53];
  }
  let t31;
  if ($[54] !== t28 || $[55] !== t30) {
    t31 = <React.Fragment>{t28}{t30}</React.Fragment>;
    $[54] = t28;
    $[55] = t30;
    $[56] = t31;
  } else {
    t31 = $[56];
  }
  let t32;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <Spacer height="0.25em" />;
    $[57] = t32;
  } else {
    t32 = $[57];
  }
  let t33;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <Link fontSize="xs" variant="underline" onClick={() => setShowStatementsModal(true)}>View Statements</Link>;
    $[58] = t33;
  } else {
    t33 = $[58];
  }
  let t34;
  if ($[59] !== t31) {
    t34 = <Box opacity={1}>{t31}{t32}{t33}</Box>;
    $[59] = t31;
    $[60] = t34;
  } else {
    t34 = $[60];
  }
  let t35;
  if ($[61] !== t26 || $[62] !== t34) {
    t35 = <Box>{t26}{t27}{t34}</Box>;
    $[61] = t26;
    $[62] = t34;
    $[63] = t35;
  } else {
    t35 = $[63];
  }
  let t36;
  if ($[64] !== t10 || $[65] !== t2 || $[66] !== t23 || $[67] !== t35) {
    t36 = <SimpleGrid columns={t2} gap={8}>{t10}{t23}{t35}</SimpleGrid>;
    $[64] = t10;
    $[65] = t2;
    $[66] = t23;
    $[67] = t35;
    $[68] = t36;
  } else {
    t36 = $[68];
  }
  let t37;
  let t38;
  if ($[69] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = t39 => {
      const {
        open
      } = t39;
      return setShowStatementsModal(open);
    };
    t38 = <Dialog.Backdrop />;
    $[69] = t37;
    $[70] = t38;
  } else {
    t37 = $[69];
    t38 = $[70];
  }
  let t39;
  let t40;
  if ($[71] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = <br />;
    t40 = {
      fontSize: "12px"
    };
    $[71] = t39;
    $[72] = t40;
  } else {
    t39 = $[71];
    t40 = $[72];
  }
  const t41 = props.subscription.subscriptionId || "--";
  let t42;
  if ($[73] !== t41) {
    t42 = <Dialog.Header borderBottom="1px solid" borderBottomColor="border.subtle">Billing Statements{t39}<span style={t40}>{"Subscription ID "}{t41}</span></Dialog.Header>;
    $[73] = t41;
    $[74] = t42;
  } else {
    t42 = $[74];
  }
  let t43;
  if ($[75] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = <Dialog.CloseTrigger />;
    $[75] = t43;
  } else {
    t43 = $[75];
  }
  let t44;
  if ($[76] !== props.subscription.subscriptionId) {
    t44 = <Dialog.Body><BillingStatementList subscriptionId={props.subscription.subscriptionId} /></Dialog.Body>;
    $[76] = props.subscription.subscriptionId;
    $[77] = t44;
  } else {
    t44 = $[77];
  }
  let t45;
  if ($[78] !== t42 || $[79] !== t44) {
    t45 = <Dialog.Positioner><Dialog.Content bgColor="colorPalette.container" maxWidth="960px" width="full">{t42}{t43}{t44}</Dialog.Content></Dialog.Positioner>;
    $[78] = t42;
    $[79] = t44;
    $[80] = t45;
  } else {
    t45 = $[80];
  }
  let t46;
  if ($[81] !== showStatementsModal || $[82] !== t45) {
    t46 = <Dialog.Root open={showStatementsModal} onOpenChange={t37}>{t38}{t45}</Dialog.Root>;
    $[81] = showStatementsModal;
    $[82] = t45;
    $[83] = t46;
  } else {
    t46 = $[83];
  }
  let t47;
  if ($[84] !== t1 || $[85] !== t36 || $[86] !== t46) {
    t47 = <Box bgColor="colorPalette.container" borderRadius="lg" boxShadow="lg" padding={t1}>{t36}{t46}</Box>;
    $[84] = t1;
    $[85] = t36;
    $[86] = t46;
    $[87] = t47;
  } else {
    t47 = $[87];
  }
  return t47;
};
const stateLabels = {
  active: 'Active',
  canceled: 'Cancelled',
  cancelled: 'Cancelled',
  non_renewing: 'Future Cancel',
  future: 'Future/Pending',
  expired: 'Cancelled',
  on_hold: 'On Hold',
  past_due: 'Past Due',
  soft_failure: 'Unpaid',
  trialing: 'Trial',
  trial_ended: 'Trial Ended',
  unpaid: 'Unpaid',
  in_trial: 'Trial'
};
const stateColors = {
  active: 'green',
  canceled: 'red.500',
  non_renewing: 'orange.500',
  expired: 'red.500',
  on_hold: 'orange.500',
  past_due: 'red.500',
  soft_failure: 'red.500',
  trialing: 'green.500',
  trial_ended: 'orange.500',
  unpaid: 'gray.500',
  in_trial: 'green.500',
  future: 'gray.500'
};